import { ColumnPattern } from '@/common/components/Table'

export const consumptionDataColumns: ColumnPattern[] = [
  { label: 'Data e Hora', value: 'consumed_at' },
  { label: 'Estabelecimento', value: 'establishment' },
  { label: 'Produto', value: 'products' },
  { label: 'Pontos', value: 'earned_points' },
  { label: 'Vlr. Total', value: 'total_amount' },
]
